import React from 'react';
import { makeStyles } from '@material-ui/core';
import Page from 'src/components/Page';
import FreeQRCode from './FreeQRCode';
import FAQs from './FAQs';
import CityViews from './CityViews'
import CTA from './CTA'
import QRCodeGallery from './QRCodeGallery'
import Recommendation from './Recommendation'

const useStyles = makeStyles(() => ({
  root: {}
}));

const HomeView = () => {
  const classes = useStyles();

  let data = {
    "@context": "http://www.schema.org",
    "@type": "Product",
    "brand": "APITier",
    "author":
      [
        {
          "@type": "Organization",
          "name": "APITier",
          "url": "https://www.apitier.com"
        }
      ],
    "name": "Free QR Code Generator",
    "description": "Create custom QR codes for your business with APITier's free QR Code Generator. Get started today and unlock the power of QR Codes to grow your business.",
    "url": "https://www.apitier.com/tools/free-qrcode-generator",
    "logo": "https://www.apitier.com/static/logo.png",
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4",
      "ratingCount": "5"
    },
    "review": {
      "@type": "Review",
      "reviewRating": {
        "@type": "Rating",
        "ratingValue": "5",
        "bestRating": "5"
      },
      "author":
        [
          { 
            "@type": "Organization",
            "name": "APITier",
            "url": "https://www.apitier.com"
          }
        ]
    } 
  };
  
  return (
    <Page
      className={classes.root}
      title="Free QR Code Generator for Your Business | APITier"
      description="Create custom QR codes for your business with APITier's free QR Code Generator. Get started today and unlock the power of QR Codes to grow your business."
      keywords="qr code generator, create qr codes,  free qr codes, qr code generator free,qr code maker, qr generator, qr code creator, qr code, qr code with logo, qr code whatsapp"
      canonicalURL="https://www.apitier.com/tools/free-qrcode-generator"
      structuredJSON={JSON.stringify(data)}
    >
      <FreeQRCode/>
      <CityViews />
      <QRCodeGallery/>
      <Recommendation />
      <CTA/>
      <FAQs/>
    </Page>
  );
};

export default HomeView;
